import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import type { AnyRouter } from '@tanstack/react-router';
import type { ReactNode } from 'react';

/**
 * Mounts a TanStack Router app into #root with a StrictMode wrapper. Optionally
 * wraps the tree with app-level providers (e.g. QueryClientProvider). Removes
 * the boilerplate every app's main.tsx repeated.
 */
export function mountApp(
  router: AnyRouter,
  options: { rootId?: string; wrap?: (children: ReactNode) => ReactNode } = {},
): void {
  const { rootId = 'root', wrap } = options;
  const el = document.getElementById(rootId);
  if (!el) throw new Error(`Root element #${rootId} not found`);

  const tree = <RouterProvider router={router} />;
  createRoot(el).render(<StrictMode>{wrap ? wrap(tree) : tree}</StrictMode>);
}
